// Centralized SEO config for all pages
// Edit this file to update meta titles, descriptions, keywords, and image alt text for each page

const seoConfig = {
  home: {
    path: '/',
    title: 'Free Typing Test — Cheetah Rank, WPM & CPM',
    description: 'No signup. Get WPM and CPM in 15 seconds to 5 minutes, then see if you type like a Snail, Turtle, Rabbit, Wolf, or Cheetah. Free on desktop and mobile.',
    keywords: 'typing test, cheetah typing test, turtle typing test, cpm typing test, wpm test, free typing test',
    imageAltText: {
      'cheetah.jpg': 'Cheetah representing a very fast typing speed rank.',
      'wolf.jpg': 'Wolf representing an advanced typist rank.',
      'rabbit.jpg': 'Rabbit representing an intermediate typist rank.',
      'turtle.jpg': 'Turtle representing a beginner typist rank.',
      'snail.jpg': 'Snail representing a slow typing speed rank.',
      'bird.jpg': 'Peregrine Falcon representing an expert typist rank, the highest achievement.',
    },
  },
  about: {
    path: '/about-typing-clicking-tests',
    title: 'About Our Tests | What is WPM, CPM & CPS Explained',
    description: 'Learn what WPM, CPM, and CPS mean and how our tests accurately measure your typing and clicking speed. Get tips to improve your scores and accuracy.',
    keywords: 'about typing test, what is wpm, what is cpm, what is cps, improve typing speed, typing accuracy, click speed explained',
    imageAltText: {},
  },
  privacy: {
    path: '/privacy',
    title: 'Privacy Policy - Typing & Clicking Tests',
    description: 'Read our privacy policy to understand how we handle your data and protect your privacy during your typing and clicking test experience.',
    keywords: 'privacy policy, typing test, data protection, user data',
    imageAltText: {},
  },
  terms: {
    path: '/terms',
    title: 'Terms and Conditions - Type Click Tests',
    description: 'Terms and conditions for using Type Click Tests, including acceptable use of our typing tests, click tests, and games.',
    keywords: 'terms and conditions, type click tests, acceptable use',
    imageAltText: {},
  },
  results: {
    title: 'Your Typing Test Results - Analyze Your WPM & Accuracy',
    description: 'View your detailed typing test results, including WPM, CPM, accuracy, and your official animal rank. Share your score or try again to beat it!',
    keywords: 'typing test results, wpm score, cpm score, typing accuracy, animal rank, keyboard speed',
    imageAltText: {},
  },
  '15s-cpm-typing-test': {
    path: '/15s-cpm-typing-test',
    title: '15 Second Typing Test — Fast WPM & CPM Burst',
    description: 'Free 15-second typing test. No signup. Instant WPM, CPM, and accuracy — the short burst most people start with.',
    keywords: '15 second typing test, quick typing test, burst wpm, short cpm test, free typing test',
    imageAltText: {},
  },
  '30s-cpm-typing-test': {
    path: '/30s-cpm-typing-test',
    title: '30 Second Typing Test — Fast WPM Check',
    description: 'Free 30-second typing test. Measure burst speed and accuracy with instant WPM and CPM. No signup, start on first keystroke.',
    keywords: '30 second typing test, short typing test, 30s wpm test, typing burst, free typing test',
    imageAltText: {},
  },
  '1min-cpm-typing-test': {
    path: '/60s-cpm-typing-test',
    title: '1 Minute Typing Test — Standard WPM & CPM',
    description: 'Classic 1-minute typing test. No signup. The standard WPM and CPM score — not a 15-second burst. Instant accuracy.',
    keywords: '1 minute typing test, one minute typing test, wpm test, 60 second typing test, cpm typing test',
    imageAltText: {},
  },
  '3min-cpm-typing-test': {
    path: '/3min-cpm-typing-test',
    title: '3 Minute Typing Test — WPM Endurance Check',
    description: 'Free 3-minute typing test for real-world speed. See if your WPM holds after the first minute. Instant accuracy and CPM, no signup.',
    keywords: '3 minute typing test, endurance typing test, long typing test, wpm stamina, free typing test',
    imageAltText: {},
  },
  '5min-cpm-typing-test': {
    path: '/5min-cpm-typing-test',
    title: '5 Minute Typing Test — Long-Form WPM Practice',
    description: 'Free 5-minute typing test. Built for long-form speed: emails, essays, code comments. Track WPM, CPM, and accuracy with no signup.',
    keywords: '5 minute typing test, long typing test, typing practice, endurance wpm, free typing test',
    imageAltText: {},
  },
  '1s-cps-click-test': {
    path: '/1s-cps-click-test',
    title: 'CPS Burst Test — 1 Second Click Speed',
    description: 'Not a typing test. Free 1-second CPS click test for raw mouse speed. Instant clicks per second, no signup.',
    keywords: '1 second click test, 1s cps test, burst cps, click speed burst, cps test',
    imageAltText: {},
  },
  '5s-cps-click-test': {
    path: '/5s-cps-click-test',
    title: 'CPS Test — Free 5 Second Click Speed Check',
    description: 'Not a typing test. The standard 5-second CPS click test. Instant clicks per second, total clicks, and a Cheetah-to-Snail click rank.',
    keywords: 'cps test, 5 second click test, click speed test, clicks per second, cps typing test, 5s cps',
    imageAltText: {},
  },
  '15s-cps-click-test': {
    path: '/15s-cps-click-test',
    title: '15 Second Click Test — CPS Stamina Check',
    description: 'Free 15-second CPS test. See if your click speed holds past the first burst. Instant total clicks and CPS, no signup.',
    keywords: '15 second click test, 15s cps, click stamina, endurance cps, free click test',
    imageAltText: {},
  },
  '30s-cps-click-test': {
    path: '/30s-cps-click-test',
    title: '30 Second Click Test — Mouse Speed Challenge',
    description: 'Free 30-second click speed test. Push clicking stamina and track live CPS. No signup, instant score.',
    keywords: '30 second click test, 30s cps, click endurance, mouse clicking test, free click test',
    imageAltText: {},
  },
  '60s-cps-click-test': {
    path: '/60s-cps-click-test',
    title: '1 Minute Click Test — CPS Marathon',
    description: 'Free 1-minute CPS test. Count total clicks and average CPS over a full minute. Built for stamina, not a one-second burst.',
    keywords: '1 minute click test, 60 second click test, cps marathon, click stamina, free click test',
    imageAltText: {},
  },
  'higher-or-lower': {
    path: '/higher-or-lower',
    title: 'Higher or Lower: Countries — Free Quiz',
    description: 'Play Higher or Lower with countries. Compare population, land area, and animal counts. Mixed rounds, instant score, no signup.',
    keywords: 'higher or lower, country population game, geography quiz, territory size game, animal population quiz, free online game',
    imageAltText: {},
  },
  'color-memory': {
    path: '/color-memory',
    title: 'Color Memory Game - Guess the Color & Score Your Accuracy',
    description: 'Free Color Memory game online. Memorize a color for 5 seconds, recreate it with sliders, and see how close your guess is with an instant accuracy score.',
    keywords: 'color memory game, guess the color, color matching game, memory game, color quiz, free online game, color accuracy test',
    imageAltText: {},
  },
  'stop-the-wheel': {
    path: '/stop-the-wheel',
    title: 'Stop the Wheel Game - Free Reaction & Timing Test',
    description: 'Free Stop the Wheel game online. Play 30 levels: stop the wheel on the target as it gets smaller and faster. Miss once and the run is over. Score out of 100.',
    keywords: 'stop the wheel, reaction test, timing game, reflex game, wheel game, accuracy test, free online game',
    imageAltText: {},
  },
  'reaction-test': {
    path: '/reaction-test',
    title: 'F1 Reaction Test — Lights Out Click Speed',
    description: 'Free F1 click / reaction test. Five red lights, then click the instant they go out. Drivers launch in 150–250 ms. Jump starts fail.',
    keywords: 'f1 reaction test, f1 click, formula 1 reaction test, lights out, reflex test, reaction time, free online game',
    imageAltText: {},
  },
  'guess-the-country': {
    path: '/guess-the-country',
    title: 'Guess the Country - Click the Map Geography Quiz',
    description: 'Free Guess the Country game online. Read a geography clue, then click the matching country on a world map. One miss ends the run — beat your highscore.',
    keywords: 'guess the country, click the map, geography quiz, country quiz, capital quiz, world map game, free online game',
    imageAltText: {},
  },
  'which-country-is-gayer': {
    path: '/which-country-is-gayer',
    title: 'Which Country Is Gayer? — LGBT Rights Quiz',
    description: 'Compare Rainbow Index, Equality Index, and marriage equality. Pick who is gayer. Winner stays. Free, no signup.',
    keywords: 'which country is gayer, lgbt rights quiz, rainbow index, equaldex, marriage equality, gay-friendly countries, free online game',
    imageAltText: {},
  },
  'click-test-results': {
    title: 'Your Click Test Results - See Your CPS Score & Rank',
    description: 'View your official click test results! See your Clicks Per Second (CPS), total clicks, and get your unique rank and a fun roast. Try again to get faster!',
    keywords: 'click test results, cps score, click speed, mouse click rank, cps rank, gaming cps',
    imageAltText: {},
  },
};

export default seoConfig;
